import { AgGridService } from "@topline/services/agGridService";
import { isTrue } from "../../Services/boolean";
import { IdSvrAuthService } from "../../auth/idSrvAuthService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";
    module.controller("marketDefinitionListCtrl", [
        "$scope",
        angularServicesNames.$uibModal,
        angularServicesNames.$translate,
        "marketDefinitionService",
        AgGridService.componentName,
        "AlertService",
        IdSvrAuthService.componentName,
        marketDefinitionListCtrl
    ]);

    function marketDefinitionListCtrl(
        this: $TSFixMe,
        $scope: $TSFixMe,
        $uibModal: ng.ui.bootstrap.IModalService,
        $translate: ng.translate.ITranslateService,
        marketDefinitionService: $TSFixMe,
        agGridService: AgGridService,
        AlertService: AlertService,
        authService: IdSvrAuthService
    ) {
        var $ctrl = this;
        $scope.model = {};
        $scope.$on("LanguageChanged", () => agGridService.refreshGridLanguage($ctrl.gridApi));

        authService.hasPermissionAsync("EditMarketDefinitions").then(result => $ctrl.canEdit = result);
        authService.hasPermissionAsync("ViewMarketDefinitions").then(result => $ctrl.canView = result);

        $ctrl.gridOptions = {
            columnDefs: [
                {
                    headerValueGetter: () => $translate.instant("MARKET.DEFINITION.IDENTIFIER"),
                    field: "identifier",
                    filter: false
                },
                {
                    headerValueGetter: () => $translate.instant("MARKET.DEFINITION.NAME"),
                    field: "name",
                    filter: "agTextColumnFilter"
                },
                {
                    headerValueGetter: () => $translate.instant("MARKET.DEFINITION.BRAND"),
                    field: "brand",
                    filter: "agSetColumnFilter"
                },
                {
                    headerValueGetter: () => $translate.instant("MARKET.DEFINITION.ACTIVE"),
                    field: "isActive",
                    filter: "agSetColumnFilter",
                    cellRenderer: (params: $TSFixMe) =>
                        params.value != null ? $translate.instant(isTrue(params.value) ? "YES" : "NO") : "",
                    filterParams: {
                        cellRenderer: (params: $TSFixMe) =>
                            params.value != null ? $translate.instant(isTrue(params.value) ? "YES" : "NO") : ""
                    }
                },
                {
                    headerValueGetter: () => $translate.instant("ACTIONS"),
                    editable: false,
                    cellRenderer: () =>
                        `<div  class="ui-grid-cell-contents" ng-if="$ctrl.canEdit">
                                <a href="#" ng-click="$ctrl.actions.edit(data)"><i class="glyphicon glyphicon-edit"></i></a>
                                <a href='#' ng-attr-title="{{ 'MARKET.DEFINITION.' + (data.isActive ? 'DEACTIVATE' :  'ACTIVATE' ) | translate }}" 
                                    ng-click='$ctrl.actions.toggleActivity(data)'  data-toggle='tooltip' data-placement='top' >
                                <i ng-if="data.isActive" class='glyphicon glyphicon-ban-circle'></i>
                                <i ng-if="!data.isActive" class='glyphicon glyphicon-ok-circle'></i>
                                </a>
                            </div>`,
                    sortable: false,
                    suppressMenu: true,
                    filter: false
                }
            ],
            domLayout: "autoHeight",
            angularCompileRows: true,
            defaultColDef: {
                sortable: true,
                resizable: true
            },
            popupParent: document.getElementById("marketDefinitionGrid"),
            enableFilter: true,
            floatingFilter: true,
            animateRows: true,
            pagination: true,
            paginationPageSize: 15,
            localeTextFunc: agGridService.transalteFunc,
            suppressHorizontalScroll: true,
            onGridReady: (config: $TSFixMe) => {
                $ctrl.gridApi = config.api;
                config.api.sizeColumnsToFit();
                loadData();
            },
            onGridSizeChanged: (config: $TSFixMe) => {
                config.api.sizeColumnsToFit();
            }
        };

        $ctrl.reloadPageSize = (pageSize: $TSFixMe) => {
            if ($ctrl.gridApi) {
                $ctrl.gridApi.paginationSetPageSize(pageSize);
            }
        };

        $ctrl.actions = {
            edit: (entity: $TSFixMe) => addOrUpdate("edit", entity),
            add: () => addOrUpdate("add", {}),
            toggleActivity: function (entity: $TSFixMe) {
                marketDefinitionService.toggleActivity(entity).then(() => loadData());
            }
        };

        function addOrUpdate(action: $TSFixMe, entity: $TSFixMe) {
            var modalInstance = $uibModal.open({
                component: "marketDefinitionEdit",
                backdrop: "static",
                windowClass: "very-wide-modal-window",
                resolve: {
                    model: () => angular.copy(entity),
                    action: () => action
                }
            });
            modalInstance.result.then((response: $TSFixMe) => {
                marketDefinitionService.edit(response).then(
                    (response: $TSFixMe) => {
                        if (response.status == HttpStatus.OK || response.status == 204) {
                            loadData();
                        } else {
                            errorHandler(response);
                        }
                    },
                    () => {}
                );
            });
        }

        function loadData() {
            if ($ctrl.canView) {
                marketDefinitionService.get().then((items: $TSFixMe) => {
                    $ctrl.gridApi.setRowData(items);
                });
            } else {
                $ctrl.gridApi.setRowData([]);
            }
        }

        const errorHandler = (err: $TSFixMe) => {
            switch (err.status) {
                case HttpStatus.Conflict:
                    AlertService.error($translate.instant("CONFIGURATION.MARKET_NAME.NAME_NOT_UNIQUE"));
                    break;
            }
        };
    }
})(angular.module("topline.modules"));
